import React from 'react';
import { Check, ShieldCheck, Crown } from 'lucide-react';

/**
 * PlanBadge — visual badge for PRO / ELITE / Verified profiles.
 * Use in profile cards, feed cards, chat headers, etc.
 */
export const PlanBadge = ({ type = 'pro', size = 'sm', className = '' }) => {
  const variants = {
    pro: {
      label: 'PRO',
      icon: ShieldCheck,
      classes: 'bg-gradient-to-r from-[#4facfe] to-[#1e90ff] text-white shadow-[0_4px_16px_rgba(79,172,254,0.45)]',
    },
    elite: {
      label: 'ELITE',
      icon: Crown,
      classes: 'bg-gradient-to-r from-[#ffa726] to-[#ff7043] text-white shadow-[0_4px_16px_rgba(255,167,38,0.45)]',
    },
    verified: {
      label: 'Verificado',
      icon: Check,
      classes: 'bg-[#4facfe]/15 text-[#4facfe] border border-[#4facfe]/30',
    },
  };
  const v = variants[type] || variants.pro;
  const Icon = v.icon;
  const sizes = {
    sm: 'text-[10px] px-2 py-0.5 gap-1',
    md: 'text-xs px-2.5 py-1 gap-1.5',
    lg: 'text-sm px-3 py-1.5 gap-2',
  };
  return (
    <span
      data-testid={`plan-badge-${type}`}
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider ${v.classes} ${sizes[size] || sizes.sm} ${className}`}
    >
      <Icon size={size === 'lg' ? 13 : size === 'md' ? 11 : 9} strokeWidth={2.5} />
      {v.label}
    </span>
  );
};

export default PlanBadge;
